import axios from "axios";

// const BASE_URL = "http://localhost:5000/";
//const BASE_URL = process.env.REACT_APP_API_URL;
const BASE_URL = "https://yummycakes-api.vercel.app/";

// const TOKEN = "";
//const TOKEN = JSON.parse(JSON.parse(localStorage.getItem("persist:root")).user).currentUser.accessToken;
const TOKEN = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2NTY2M2M4OTkwYWU4MWQyOWI1YjJmNDYiLCJpc0FkbWluIjp0cnVlLCJpYXQiOjE3MDExOTkxNjcsImV4cCI6MTcwMzc5MTE2N30.XqXDZn9CHOUeGPjeKbv5HaUi9u6HmTYZHa_-VyQosC4";

// console.log(JSON.parse(JSON.parse(localStorage.getItem("persist:root")).user).currentUser.accessToken)
// console.log((JSON.parse(localStorage.getItem("persist:root")).user))

export const publicRequest = axios.create({
    baseURL: BASE_URL,
});
export const userRequest = axios.create({
    baseURL: BASE_URL,
    headers: {token: `Bearer ${TOKEN}`},
});
